<template>
    <div class="mb-5 pm-block" style="min-height: unset">
        <div v-if="invalid" class="text-xs-center pa-4 d-flex align-center">
            <div style="width: 100%;" class="pm-block-main">
                <div>
                    <div class="pm-block-title">Progress Monitoring</div>
                    <span class="pm-block-subtitle">
                        Link a measure to display. This field will not print unless progress monitoring is linked.
                    </span>
                </div>
                <fe-btn usage="secondary" 
                    @click="showLinkForm = true"
                    data-test="smartform-pm-link-intervention-btn"
                    role="button"
                    tabindex="0"
                    aria-label="Open link interventions"
                    @keydown.enter="showLinkForm = true"
                    @keydown.space.prevent="showLinkForm = true"
                >
                    <v-icon class="mr-2">fal fa-link</v-icon>Link Progress Monitoring
                </fe-btn>
            </div>
        </div>

        <div v-else class="ma-4">
            <div v-for="(plan, i) in linkedToFormField" :key="plan.student_monitor_plan_id || `pmblock-`+i">
                <div class="mb-2 align-center d-flex modal-title" style="font-size: 18px;">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <fe-btn v-on="on" usage="secondary">
                                Update Progress Monitor <v-icon class="ml-2">fal fa-chevron-down</v-icon>
                            </fe-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="showLinkForm = true"
                                data-test="smartform-pm-block-select-new-pm-btn"
                            >
                                Select Another Progress Monitor
                            </v-list-item>
                            <v-list-item @click="removePM()"
                                style="color: #BF0D00;"
                                data-test="smartform-pm-block-remove-pm-btn"
                            >
                                Remove Progress Monitor
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
                <behavior-progress-monitoring v-if="plan.category_id === 4" :params="getParamsForMonitor(plan)" @dateChange="dateChange" />
                <academic-progress-monitoring v-else showStatement :params="getParamsForMonitor(plan)" />
            </div>
        </div>

        <link-progress-monitoring 
            ref="pmLinkForm" 
            v-model="showLinkForm" 
            :formInstance="params.form_instance" 
            :fieldRec="fieldRec" 
            :linkedPMs="params.progress_monitors" 
            @reload="onReload" 
        />
    </div>
</template>

<script>
    import AcademicProgressMonitoring from '@/components/charts/AcademicProgressMonitoring'
    import BehaviorProgressMonitoring from '@/components/charts/BehaviorProgressMonitoring'
    import LinkProgressMonitoring from './LinkProgressMonitoring'

    export default {
        name: 'ProgressMonitoringBlock',
        props: {
            params: {
                type: Object,
                default: () => ({})
            },
            fieldRec: {
                type: Object,
                default: () => ({})
            }
        },
        components: {
            AcademicProgressMonitoring,
            BehaviorProgressMonitoring,
            LinkProgressMonitoring,
        },
        computed: {
            invalid() {
                return !this.params?.progress_monitors?.length || !this.linkedToFormField.length
            },
            linkedToFormField() {
                return this.params?.progress_monitors?.filter(x => x.form_field_id === this.fieldRec?.form_field_id) || []
            },
        },
        data() {
            return {
                showLinkForm: false,
            }
        },
        methods: {
            getParamsForMonitor(plan) {
                return {
                    ...this.params,
                    progress_monitors: [plan],
                    student_monitor_plan_id: plan.student_monitor_plan_id,
                    intervention_id: plan.intervention_id
                }
            },
            onReload() {
                this.$emit('reloadInterventionLink')
            },
            async removePM() {
                let existing = await this.$refs?.pmLinkForm?.getPMs()
                const interventionId = this.params?.progress_monitors?.[0]?.intervention_id
                let planToRemove = existing.find(x => x?.intervention_id === interventionId)
                if (planToRemove) this.$refs?.pmLinkForm?.doUnlink(planToRemove)
            },
            dateChange(v) {
                let formField = this.fieldRec?.form_field_id
                let startDate = 'form_field_id_' + formField + '_start_date=' + v?.start_date
                let endDate = 'form_field_id_' + formField + '_end_date=' + v?.end_date
                this.$emit('behaviorPMDates', startDate + '&' + endDate)
            }
        },
    }
</script>

<style lang="scss" scoped>
    .pm-block {
        border: 1px solid #E0E1E6;
        border-radius: 4px;
        justify-content: space-between;
        margin: 8px 0 8px 0;
        &-title {
            font-size: 16px; 
            font-family: 'HyperlegibleSans-Medium', Hyperlegible Sans, 'Roboto', sans-serif;
        }
        &-subtitle {
            color: #495B8F;
        }
        &-main {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
    .modal-title {
        justify-content: flex-end;
    }
</style>
